<script>
import { Doughnut } from 'vue-chartjs'

const colors = [
  '#25A4DF', // Blue
  '#44B469', // Green
  '#9AAEB9', // Gray
  '#E46651', // Red
  '#00D8FF', // Light Blue
  '#F87979', // Reddish Pink
  '#66D7D1', // Teal
  '#E6B89C', // Peach
  '#EAD2AC', // Tan
  '#4281A4', // Dark Greenish-Blue
  '#C9683B', // Orange
  '#431B35', // Purple
  '#EF6461', // Pastel Red
  '#E4B363', // Earth Yellow
  '#313638', // Onyx
  '#5ADBFF', // Maya Blue
  '#FE9000', // Dark Orange
  '#466060', // Deep Space Sparkle
  '#0E0F19', // Smoky Black
  '#CBF7ED', // Aero Blue
  '#23395B', // Japanese Indigo
  '#CDE7B0', // Tea Green
  '#EF476F', // Infra Red
  '#26547C', // B'dazzled Blue
  '#1C3738', // Medium Jungle Green
  '#4C3957', // Pineapple (not pineapple)
  '#C68866', // Pale Copper
  '#F5F749', // Lemon yellow
  '#565554', // Davy's Grey
  '#F24236', // Vermilion
  '#84BCDA', // Dark Sky Blue
  '#F37748', // Mandarin
  '#7F7EFF', // Medium Slate Blue
  '#C69DD2', // Wisteria
  '#CC8B8C', // Puce
  '#593837', // Dark Liver (horses) -> Why on earth is this horse specific?
  '#CCC9E7' // Soap
]

const LIMIT = 15
let maxAge = 0
let ageIndices = {}
let maxAgeLabels = []

export default {
  extends: Doughnut,
  props: ['height', 'apiData', 'chartName', 'valueField', 'groupedBy'],
  computed: {
    chartData: function () {
      return this.values
    },
    labels: function () {
      const apiLabels = this._.map(this.apiData, 'demographic')
      let labels = []

      _.forEach(apiLabels, (l, id) => {
        if (l === '' || l === null) {
          labels.push('Not Specified')
        } else {
          labels.push(l)
        }
      })

      // If grouped by age, display data by age groups
      if (this.groupedBy === 'b_birthdate' &&
        labels.length > LIMIT) {
        // Save the order of ages
        ageIndices = {}
        const ages = labels.filter((label, id) => {
          ageIndices[id] = !isNaN(parseInt(label)) ? parseInt(label) : 'Unknown'
          return label !== 'Unknown'
        }).map(label => parseInt(label))
        // Sort ages
        ages.sort((a, b) => a - b)

        // Reset labels to group ages by 5
        labels = labels.includes('Unknown') ? ['Unknown'] : []
        let i = 0
        maxAge = ages[ages.length - 1]
        maxAgeLabels = []
        while (i <= maxAge) {
          labels.push(`${i} - ${i + 5}`)
          maxAgeLabels.push(i + 5)
          i += 6
        }
      }
      return labels
    },
    values: function () {
      const values = this._.map(this.apiData, this.valueField)
      if (this.groupedBy === 'b_birthdate' &&
        values.length > LIMIT) {
        const groupedValues = []
        const doesNotSpecifiedExist = Object.values(ageIndices).includes('Unknown')
        groupedValues.length = doesNotSpecifiedExist ? maxAgeLabels.length + 1 : maxAgeLabels.length
        groupedValues.fill(0)
        for (let i = 0; i < values.length; i++) {
          const age = ageIndices[i]
          // Find age that it fits into
          if (age === 'Unknown') {
            groupedValues[0] = values[i]
            continue
          }
          for (let j = 0; j < maxAgeLabels.length; j++) {
            if (age <= maxAgeLabels[j]) {
              if (doesNotSpecifiedExist) {
                groupedValues[j + 1] += values[i]
              } else {
                groupedValues[j] += values[i]
              }
              break
            }
          }
        }
        return groupedValues
      }
      return values
    }
  },
  methods: {
    renderPieChart: function () {
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              label: this.chartName,
              backgroundColor: colors,
              data: this.chartData
            }
          ]

        },
        {
          responsive: false,
          maintainAspectRatio: false,
          cutoutPercentage: 25
        }
      )
    }
  },
  watch: {
    apiData: function () {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }

      this.renderPieChart()
    }
  },
  mounted () {
    this.renderPieChart()
  }
}
</script>
<style>
#doughnut-chart {
  margin-bottom: 1rem;
  height: auto !important;
}
</style>


// WEBPACK FOOTER //
// src/views/charts/PieChart.vue